import Vue from 'vue'

Vue.filter('capitalize', value => {
  if (!value) return ''
  value = value.toString()
  let strings = value.split('_')

  return strings
    .map(str => {
      return str.charAt(0).toUpperCase() + str.slice(1)
    })
    .join(' ')
})



// WEBPACK FOOTER //
// ./client/filters/index.js